import { useGetMainSearchQuery } from '@/app/(main)/search/hooks/useGetMainSearchQuery';
import { goToSearchDetails } from '@/app/(main)/search/utils/goToSearchDetailsPath';
import { SEARCH_CATEGORIES } from '@/consts/search-const';
import type { GlobalSearchAnnouncementsItem, GlobalSearchCategory } from '@/types/globalSearchApiTypes';
import { AnnouncementsItem } from '../AnnouncementsItem';
import { CategoryWrapper } from '../CategoryWrapper';

interface AnnouncementsCategoryProps {
  data: GlobalSearchCategory<GlobalSearchAnnouncementsItem>;
}

export const AnnouncementsCategory = ({ data }: AnnouncementsCategoryProps) => {
  const { search } = useGetMainSearchQuery();
  return (
    <CategoryWrapper
      categoryName="Announcements"
      itemsCount={data.count}
      redirectToDetails={goToSearchDetails({ category: SEARCH_CATEGORIES.ANNOUNCEMENTS, searchQuery: search })}
    >
      {data.results.map((item) => (
        <AnnouncementsItem key={item.title} item={item} />
      ))}
    </CategoryWrapper>
  );
};